import { BaseCardWrapper } from '@healthhub/react-ui';
import { Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import LookForEServiceCard from './LookForEServiceCard';
import type { IEservicesGroupModule } from '../types/eservices';

const { Text } = Typography;

interface LookForEServicesSearchResultsProps {
  filterModules: IEservicesGroupModule[];
  searchInputValue: string;
}

const LookForEServicesSearchResults = ({ filterModules, searchInputValue }: LookForEServicesSearchResultsProps) => {
  const { t } = useTranslation('home');
  const moduleLength = filterModules.length;

  return (
    <div className="px-3 py-2 md:px-8 lg:p-0">
      <BaseCardWrapper className="flex flex-col gap-6">
        <Text className="self-center text-xl">
          <Trans
            components={{
              1: <span className="font-semibold text-primary-blue-grey" />,
              2: <span className="font-semibold text-primary-blue-grey" />,
            }}
            i18nKey="showingResultsFor"
            t={t}
            values={{ count: moduleLength, searchInputValue }}
          />
        </Text>
        <div className="grid auto-rows-fr grid-cols-1 gap-2 lg:grid-cols-3 lg:gap-6">
          {filterModules.map(({ description, icon, label, onClick, publicDescription, publicUrl, url }) => (
            <LookForEServiceCard
              description={description}
              icon={icon}
              key={label}
              label={label}
              onClick={onClick}
              publicDescription={publicDescription}
              publicUrl={publicUrl}
              url={url}
            />
          ))}
        </div>
      </BaseCardWrapper>
    </div>
  );
};

export default LookForEServicesSearchResults;
